import { render } from "./Visited.vue?vue&type=template&id=70e91da4&scoped=true"
import script from "./Visited.vue?vue&type=script&lang=js"
export * from "./Visited.vue?vue&type=script&lang=js"

import "./Visited.vue?vue&type=style&index=0&id=70e91da4&scoped=true&lang=css"

import exportComponent from "E:\\01.Progetti\\GitHub\\SCIENZE_NATURALI_app\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70e91da4"]])

export default __exports__